import { GetLocationsResponseDTO } from '@gearbelt/global';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';

import { Checkbox } from '@/components/ui/checkbox';

const columnHelper = createColumnHelper<GetLocationsResponseDTO['data'][number]>();

export const createLocationsTableColumns = ({ canManageLocations = true }: { canManageLocations?: boolean } = {}) =>
  [
    canManageLocations &&
      columnHelper.display({
        id: 'select',
        header: ({ table }) => (
          <div className="flex w-full justify-center">
            <label className="-m-2 p-2">
              <Checkbox
                checked={table.getIsAllPageRowsSelected()}
                onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                aria-label="Select all"
              />
            </label>
          </div>
        ),
        cell: ({ row }) => (
          <div className="flex w-full justify-center">
            <label className="-m-2 p-2" onClick={(e) => e.stopPropagation()}>
              <Checkbox checked={row.getIsSelected()} onCheckedChange={(value) => row.toggleSelected(!!value)} aria-label="Select row" />
            </label>
          </div>
        ),
        meta: {
          cellClassName: 'w-[40px] min-w-[40px] max-w-[40px]',
        },
        enableSorting: false,
        enableHiding: false,
      }),
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Location Name',
    }),
    columnHelper.accessor('id', {
      id: 'id',
      header: 'Location ID',
    }),
    columnHelper.accessor('address', {
      id: 'address',
      header: 'Address',
      cell: ({ getValue }) => getValue() || '-',
    }),
    columnHelper.accessor('assetCount', {
      header: 'Assets',
      cell: ({ row }) => {
        const { assetCount } = row.original;
        return <span>{assetCount}</span>;
      },
    }),
  ].filter(Boolean) as AccessorKeyColumnDef<GetLocationsResponseDTO['data'][number]>[];
